<template>
  <div>
    <div class="credential pb-2">
      <div class="inner-title">1. Business Verticals in regions you can partner</div>
      <div class="table-wrapper-scroll-y my-custom-scrollbar-business-vertical">
        <table class="table table-striped mb-0 text-left">
          <thead>
            <tr>
              <th scope="col">Sl No</th>
              <th scope="col">Business Type</th>
              <th scope="col">Business Vertical</th>
              <th scope="col">Region</th>
              <th scope="col">Primary Business</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(businessVertical,index) in credential.businessVerticals" :key="index">
              <td scope="col">{{index+1}}</td>
              <td scope="col">{{businessVertical.businessType}}</td>
              <td scope="col">{{businessVertical.businessVertical}}</td>
              <td scope="col">{{businessVertical.region}}</td>
              <td scope="col">{{businessVertical.primaryBusinessAs}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="credential pb-2">
      <div class="row">
        <div
          class="col-sm inner-title"
        >2. Have you been or are you a partner with any other Division of L&T ?</div>
        <div class="col-sm text-left" v-if="credential.isExistingPartner == 'N'">No</div>
        <div class="col-sm text-left" v-if="credential.isExistingPartner == 'Y'">Yes</div>
      </div>
      <div
        v-if="credential.isExistingPartner == 'Y'"
        class="table-wrapper-scroll-y my-custom-scrollbar"
      >
        <table class="table table-striped mb-0">
          <thead>
            <tr>
              <th scope="col">Sl No</th>
              <th scope="col">OD Details</th>
              <th scope="col">Partner Code</th>
              <th scope="col">If currently not active,State reason</th>
            </tr>
          </thead>
          <tbody class="text-left">
            <tr v-for="(existingPartner,index) in credential.existingPartners" :key="index">
              <td scope="col">{{index+1}}</td>
              <td scope="col">{{existingPartner.odDetails}}</td>
              <td scope="col">{{existingPartner.vendorCode}}</td>
              <td scope="col">{{existingPartner.reason}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <div class="row" v-if="credential.isExistingPartner == 'Y'">
        <div class="col-sm text-left">OD Details</div>
        <div class="col-sm text-left">{{credential.existingPartner.odDetails}}</div>
      </div>
      <div class="row" v-if="credential.existingPartner.isExist == 'Y'">
        <div class="col-sm text-left">Vendor Code</div>
        <div class="col-sm text-left">{{credential.existingPartner.vendorCode}}</div>
      </div>

      <div class="row" v-if="credential.existingPartner.isExist == 'Y'">
        <div class="col-sm text-left">If Delisted/Blacklisted,State the Reason</div>
        <div class="col-sm text-left">{{credential.existingPartner.reason}}</div>
      </div>-->
    </div>

    <div class="credential" v-if="!branchLogIn">
      <div class="row">
        <div
          class="col-sm inner-title"
        >3. Is there any L&T employee related to senior management in your Organization?</div>
        <div class="col-sm text-left" v-if="credential.isLntEmployeeExist == 'N'">No</div>
      </div>
      <div
        v-if="credential.isLntEmployeeExist == 'Y'"
        class="table-wrapper-scroll-y my-custom-scrollbar"
      >
        <table class="table table-striped mb-0">
          <thead>
            <tr>
              <th scope="col">Sl No</th>
              <th scope="col">Contact Name</th>
              <th scope="col">Designation</th>
              <th scope="col">Email</th>
              <th scope="col">Mobile Number</th>
            </tr>
          </thead>
          <tbody class="text-left">
            <tr v-for="(lntEmployee,index) in credential.lntEmployee" :key="index">
              <td scope="col">{{index+1}}</td>
              <td scope="col">{{lntEmployee.contactName}}</td>
              <td scope="col">{{lntEmployee.designation}}</td>
              <td scope="col">{{lntEmployee.email}}</td>
              <td scope="col">{{lntEmployee.mobileNumber}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["credential","branchLogIn"]
};
</script>
<style scoped>
.inner-title {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  text-align: left;
  font-stretch: normal;
  line-height: 1.25;
  text-align: left;
  padding-bottom: 1%;

  /* width: 600px;
  height: 36px;
  font-family: SourceSansProSemiBold;
  font-size: 14px;
  font-weight: 700;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.06;
  letter-spacing: 0.16px;
  text-align: left;
  color: #212121; */
}
.my-custom-scrollbar-business-vertical {
  /* position: relative; */
  max-height: 300px;
  width: 100%;
  overflow: auto;
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #d0d3d6;
  background-color: #6192b1;
  position: sticky;
  color: #fff;
  text-align: left;
}
/* .business-vertical {
  padding-bottom: 30px;
  font-family: "Source Sans Pro", sans-serif;
}
.existing-partner {
  font-size: 14px;
  padding-bottom: 20px;
  font-family: "Source Sans Pro", sans-serif;
  text-align: left;
} */
.credential {
  font-size: 14px;
  font-family: "Source Sans Pro", sans-serif;
}
</style>